// hooks/useSearch.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }

    if (searchQuery.trim()) {
      // Navegar a la página de búsqueda con el query como parámetro
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return {
    searchQuery,
    setSearchQuery,
    handleSearch,
    handleKeyPress,
  };
};

export default useSearch;
